import * as React from 'react';
import './NoDataPanel.scss';

const Index = ({title, description}:{title:string,description:string}) => {
  return (
    <div className='BoxContent'>
      <div style={{ color: 'gray', textAlign: 'center' }}>
        <h3 style={{ marginBottom: -5, marginTop: '15%' }}>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default Index;
